
import { Component, Prop, Vue } from 'vue-property-decorator';

export interface ProductType {
  id: number;
  name: string;
  icon: string;
  iconSize: number;
  product_id: number;
  product_model: string;
}

@Component({})
export default class ProductTypeSelector extends Vue {
  @Prop({ type: Number, required: false }) private readonly tabIndex!: number;

  private productTypes: ProductType[] = [
    {
      id: 1,
      name: 'Small Printer',
      icon: 'mdi-printer',
      iconSize: 48,
      product_id: 9541, // Generic product ID for small printer
      product_model: 'AA-BOX',
    },
    {
      id: 2,
      name: 'Large Printer',
      icon: 'mdi-printer',
      iconSize: 64,
      product_id: 9541, // Generic product ID for large printer
      product_model: 'AA-BOX',
    },
    {
      id: 3,
      name: 'Small Display',
      icon: 'mdi-television',
      iconSize: 48,
      product_id: 9541, // Generic product ID for copier
      product_model: 'AA-BOX',
    },
    {
      id: 4,
      name: 'Large Display',
      icon: 'mdi-television',
      iconSize: 64,
      product_id: 9541, // Generic product ID for large copier
      product_model: 'AA-BOX',
    },
  ];

  private selectProductType(productType: ProductType): void {
    this.$emit('select', {
      product_id: productType.product_id,
      name: productType.product_model,
    });
  }
}
